import React, { useEffect, useState } from "react";
import { BsThreeDots } from "react-icons/bs";
import NoData from "../../Component/NoData/NoData";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import { BaseURL, endpointsUrl, recordsLimit } from "../../config/apiUrl";
import classes from "./NotificationsPage.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Get } from "../../Axios/AxiosFunctions";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { IoIosNotificationsOutline } from "react-icons/io";
import { Loader } from "../../Component/Loader";
import PaginationComponent from "../../Component/PaginationComponent";

const NotificationsPage = () => {
  const navigate = useNavigate();
  const { access_token, user } = useSelector((state) => state.authReducer);
  const [loading, setLoading] = useState(false);
  const [totalNotification, setTotalNotification] = useState(0);
  const [apiData, setApiData] = useState([]);
  const [page, setPage] = useState(1);

  // getData
  const getData = async (e) => {
    const url = BaseURL(`notifications/all?page=${page}&limit=${recordsLimit}`);
    setLoading(true);
    const response = await Get(url, access_token);
    if (response) {
      setApiData(response?.data?.data);
      setTotalNotification(response?.data?.totalCount);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <>
      <style>{`
      .table100-body{
        height:calc(100vh - 310px);
        overflow-y:scroll;
      }
  @media screen and (max-width:1440px){
      .table100-head, .table100-body{
        width:1200px;
      }
      .table100.ver1{
        overflow-x:scroll !important;
      }
    }

      `}</style>
      <div>
        <SideBarSkeleton>
          <Container className={classes.main}>
            <Row className={classes.row}>
              <Col md={12}>
                <h5>Notifications</h5>
              </Col>
              <Col md={12}>
                <div className={classes.__content}>
                  {loading ? (
                    <Loader className={classes.loader} />
                  ) : apiData.length > 0 ? (
                    apiData.map((element, i) => (
                      <div
                        key={i}
                        className={classes.notificationBox}
                        onClick={() => {
                          navigate(`/VideoDetails/${element?.video}`);
                        }}
                      >
                        <div className={classes.notification}>
                          <div className={classes.notificationIcon}>
                            <IoIosNotificationsOutline
                              size={30}
                              className={classes.icon}
                            />
                          </div>
                          <div className={classes.notificatinText}>
                            {element?.message}
                          </div>
                        </div>
                        <div className={classes.time}>
                          {moment(element?.createdAt).format(
                            "Do MMM YYYY, hh:mm A"
                          )}{" "}
                        </div>
                      </div>
                    ))
                  ) : (
                    <NoData
                      text="Notifications Not Found"
                      className={classes.noData}
                    />
                  )}
                </div>
              </Col>
            </Row>
            <div className={classes.paginationDiv}>
              <PaginationComponent
                currentPage={page}
                setCurrentPage={setPage}
                totalPages={Math.ceil(totalNotification / recordsLimit)}
              />
            </div>
          </Container>
        </SideBarSkeleton>
      </div>
    </>
  );
};
export default NotificationsPage;
